import React from "react";
import ChevronRightRoundedIcon from "@mui/icons-material/ChevronRightRounded";
import styles from "../Organigrama.module.scss";

const cx = (...cls) => cls.filter(Boolean).join(" ");

/**
 * Card de un nodo en la vista en cascada. Se ubica en la grilla por
 * `gridColumn` (columna de su tipo) y `gridRow` (fila calculada por el DFS).
 *
 * Dos gestos: click en la card = SELECCIONAR; click en la flecha = EXPANDIR.
 *
 * @param agentes      agentes asignados al nodo.
 * @param agentesEnRama los del nodo mas los de todos sus descendientes.
 *
 * El badge muestra el ACUMULADO cuando la card esta cerrada y tiene hijos, y el PROPIO cuando
 * esta abierta o es una hoja. Cerrada, lo util es saber si vale la pena abrirla; abierta, los
 * hijos ya muestran lo suyo y repetir la suma seria contar dos veces lo mismo.
 */
export default function NodoCascada({ nodo, col, row, activo, expandido, expandible, agentes = 0, agentesEnRama = 0, onSelect, onToggle }) {
    // Solo los usa el badge de agentes, que esta comentado mas abajo.
    // const muestraRama = expandible && !expandido;
    // const conteo = muestraRama ? agentesEnRama : agentes;
    const tipoClass = styles[`card_${nodo.rnhTipoEstructuraCod}`];

    // TODA card selecciona, hojas incluidas (Puesto, Posta, URESA). La seleccion es
    // el target de "Ver agentes", y a un agente se lo asigna a cualquier componente,
    // no solo a los contenedores. "Gestionar" sigue limitado a contenedores, pero eso
    // lo resuelve la pagina con su propio disabled y no la card.
    const handleClick = () => onSelect(nodo);
    const handleKeyDown = (e) => {
        if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            handleClick();
        }
    };
    const handleExpandir = (e) => {
        e.stopPropagation(); // no dispara la selección de la card
        onToggle(nodo);
    };

    return (
        <div
            className={cx(
                styles.card,
                tipoClass,
                expandido && !activo && styles.cardExpandido,
                activo && styles.cardActiva,
                styles.cardClickable
            )}
            style={{ gridColumn: col, gridRow: row }}
            data-nid={nodo.rnhEstablecimientoEstructuraId}
            onClick={handleClick}
            onKeyDown={handleKeyDown}
            role="button"
            tabIndex={0}
        >
            <div className={styles.cardTop}>
                <span className={styles.cardNombre}>{nodo.rnhEstructuraNombre}</span>
                {/* Badge de cantidad de agentes, oculto por ahora.
                <span
                    className={cx(styles.cardAgentes, conteo === 0 && styles.cardAgentesVacio)}
                    title={
                        muestraRama
                            ? `${conteo} ${conteo === 1 ? "agente" : "agentes"} en esta rama`
                            : `${conteo} ${conteo === 1 ? "agente" : "agentes"}`
                    }
                >
                    {conteo}
                </span>
                */}
                {expandible && (
                    <button
                        type="button"
                        className={styles.cardChevronBtn}
                        onClick={handleExpandir}
                        title={expandido ? "Colapsar" : "Expandir"}
                        aria-label={expandido ? "Colapsar" : "Expandir"}
                    >
                        <ChevronRightRoundedIcon
                            fontSize="small"
                            className={cx(styles.cardChevron, expandido && styles.cardChevronAbierto)}
                        />
                    </button>
                )}
            </div>
        </div>
    );
}
